
const PlanChangesData = (props) => {
    const { data } = props;
    const uniqueRows = [];
    const dataRows = data.map((row) => {
      return {
        id:
          row.agentId +
          row.carrierId +
          row.effectivedate +
          row.county +
          row.state,
        agentName: row.agentname,
        carrierName: row.carrierName,
        companyName: row.companyName,
        hlevel: row.hlevel,
        ma_production: row.maProduction,
        medsupp_production: row.medsuppProduction,
        pdp_production: row.pdpProduction,
        uplines: row.uplines,
        county: row.county,
        state: row.state,
        effectivedate: row.effectivedate,
        planYear: new Date(row.effectivedate).getFullYear().toString(),
      };
    });
  
    dataRows.forEach((row) => {
      if (!uniqueRows.find((existingRow) => existingRow.id === row.id)) {
        uniqueRows.push(row);
      }
    });

    return uniqueRows;
}

export default PlanChangesData;

